import { useContext, useState } from "react";
import React from "react";
import Service from "../cards/serviceCard";
import PageTitle from "./pageTitle";
import { Link } from "react-router-dom";
import { ServiceContext } from "../../App";
import ReactPaginate from "../common/ReactPaginate";
import ContactForm from "../cards/contactForm";
import MailSubscription from "../cards/emailSub";
import { Helmet } from "react-helmet-async";
import ServicePageSkeleton from "./skeletons/servicePage";

function Items({ currentItems }: any) {
  return (
    <section className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-py-10">
      <div className="cht-grid cht-grid-cols-1 md:cht-grid-cols-2 lg:cht-grid-cols-3 cht-gap-6 sm:cht-gap-8">
        {currentItems &&
          currentItems.map((item: any) => (
            <Service
              key={item?.id || item?.slug}
              id={item?.id}
              slug={item?.slug}
              title={item?.title}
              body={item?.safe_description_html}
              image={item?.get_image_url}
              category={item?.category}
              technologies={item?.technologies}
            />
          ))}
      </div>
    </section>
  );
}

function PaginatedItems({ itemsPerPage, data }) {
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const services = data;
  const items = Object.values(services);
  const [itemOffset, setItemOffset] = useState(0);

  // Simulate fetching items from another resources.
  // (This could be items from props; or items loaded in a local state
  // from an API endpoint with useEffect and useState)
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = items.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(items.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };

  return (
    <div className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-pb-16">
      <Items currentItems={currentItems} />

      {Object.keys(items).length > itemsPerPage ? (
        <ReactPaginate
          previousLabel={"Prev"}
          nextLabel={"Next"}
          breakLabel="..."
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          renderOnZeroPageCount={null}
          marginPagesDisplayed={3}
          containerClassName={"cht-flex cht-items-center cht-justify-center cht-gap-1 sm:cht-gap-2 cht-my-10 cht-list-none cht-p-0"}
          pageClassName={""}
          pageLinkClassName={"cht-w-10 cht-h-10 cht-flex cht-items-center cht-justify-center cht-rounded-xl cht-text-sm !cht-font-body cht-font-semibold cht-text-slate-600 hover:cht-bg-slate-100 hover:cht-text-[#3e57da] cht-transition-all cht-duration-200 cht-border cht-border-slate-200/80 !cht-no-underline"}
          previousClassName={""}
          previousLinkClassName={"cht-px-4 cht-h-10 cht-flex cht-items-center cht-justify-center cht-rounded-xl cht-text-sm !cht-font-body cht-font-semibold cht-text-slate-600 hover:cht-bg-slate-100 hover:cht-text-[#3e57da] cht-transition-all cht-duration-200 cht-border cht-border-slate-200/80 !cht-no-underline"}
          nextClassName={""}
          nextLinkClassName={"cht-px-4 cht-h-10 cht-flex cht-items-center cht-justify-center cht-rounded-xl cht-text-sm !cht-font-body cht-font-semibold cht-text-slate-600 hover:cht-bg-slate-100 hover:cht-text-[#3e57da] cht-transition-all cht-duration-200 cht-border cht-border-slate-200/80 !cht-no-underline"}
          breakClassName={""}
          breakLinkClassName={"cht-w-10 cht-h-10 cht-flex cht-items-center cht-justify-center cht-text-sm cht-text-slate-400"}
          activeClassName={"[&>a]:!cht-bg-[#3e57da] [&>a]:!cht-text-white [&>a]:!cht-border-[#3e57da] [&>a]:!cht-shadow-sm"}
          disabledClassName={"[&>a]:!cht-opacity-40 [&>a]:!cht-pointer-events-none"}
        />
      ) : null}
    </div>
  );
}

function Services() {
  const { service, serviceLoading } = useContext(ServiceContext);

  return (
    <>
      <Helmet>
        <title>Services - Codehub Technologies</title>
      </Helmet>

      <PageTitle title="Services" />

      {Object.keys(service).length === 0 ? null : (
        <PaginatedItems itemsPerPage={9} data={service} />
      )}

      {serviceLoading && <ServicePageSkeleton numberOfCols={3} />}

      <MailSubscription />
      <ContactForm />
    </>
  );
}

export default Services;
